import { sanitizeAnamnesisTelemetryPayload } from '@/features/encounters/anamnesis/anamnesisTechnicalTelemetry'
import { sanitizeLangfuseMetadata } from '@/shared/observability/telemetry.sanitizer'
import { isSentrySanitizedMode } from '@/shared/monitoring/sentry.helpers'

export { sanitizeLangfuseMetadata, isLangfuseContentEnabled, isLangfuseSanitizedMode } from '@/shared/observability/telemetry.sanitizer'

/** Metadados seguros para tags/extra/context do Sentry (sem PHI). */
export const sanitizeSentryAnamnesisContext = (
  payload: Record<string, string | number | boolean | null | undefined> = {},
): Record<string, string | number | boolean> => {
  const sanitized = sanitizeAnamnesisTelemetryPayload(payload)
  const out: Record<string, string | number | boolean> = {}
  for (const [key, value] of Object.entries(sanitized)) {
    if (value == null) continue
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      out[key] = value
    }
  }
  if (isSentrySanitizedMode()) {
    return out
  }
  return sanitizeLangfuseMetadata(out) as Record<string, string | number | boolean>
}
